// Ajoute .is-scrolled à .appbar quand on scroll
const appbar = document.querySelector('.appbar');
if (appbar) {
    const onScroll = () => appbar.classList.toggle('is-scrolled', window.scrollY > 6);
    onScroll(); window.addEventListener('scroll', onScroll, { passive: true });
}
